import { Component, OnInit, Input } from '@angular/core';
import { ShippingAddress } from '../../../../models/check-out.model';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../../services/checkout.service';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../../../services/common.service';
import { AccountDeliveryAddress } from '../../../../models/account-delivery-address';

@Component({
  selector: 'app-partship-summary',
  templateUrl: './partship-summary.component.html',
  styleUrls: ['./partship-summary.component.css']
})
export class PartshipSummaryComponent implements OnInit {

  @Input() partshipSummary: ShippingAddress;
  @Input() enableEdit: boolean;
  deliveryAddress: AccountDeliveryAddress;

  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService
    , private ngProgress: NgProgress
    , private commonService: CommonService) { }

  ngOnInit() {
  }

  editPartshipSummary(): void {
    this.deliveryAddress = {
      companyName: this.partshipSummary.companyName,
      attnOrRef: this.partshipSummary.attnRef,
      addressLine1: this.partshipSummary.addressLine1,
      addressLine2: this.partshipSummary.addressLine2,
      addressLine3: this.partshipSummary.addressLine3,
      suburb: this.partshipSummary.suburb,
      state: this.partshipSummary.state,
      postcode: this.partshipSummary.postcode,
      phone: this.partshipSummary.phone,
      naType: this.partshipSummary.salesTypeTab,
      action: 'U',
    };
    this.checkOutService.monitorEditAddress(this.deliveryAddress);
    this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute.parent });
  }
}
